import React from "react";
import "./DetailPaneMessageCard.scss";

type DetailPaneMessageCardProps = {
    readonly heading: string;
    readonly description: React.ReactNode;
    /** Optional call to action rendered under the description. */
    readonly action?: React.ReactNode;
};

/**
 * The centered grey card a detail pane shows in place of study results: used
 * when a bus is locked, and when we're asking whether to unlock it.
 */
const DetailPaneMessageCard: React.FC<DetailPaneMessageCardProps> = (props) => {
    const { heading, description, action } = props;

    return (
        <div className="DetailPaneMessageCard-wrapper">
            <h5 className="DetailPaneMessageCard-heading bp5-heading">
                {heading}
            </h5>
            <p className="DetailPaneMessageCard-description">{description}</p>
            {action}
        </div>
    );
};

export default DetailPaneMessageCard;
